<template>
  <div class="engineer-page">
    <h3 class="page-title3">工程师维护</h3>
    <el-button class="btn" @click="handleOpenDialog()">新增工程师</el-button>
    <el-form :inline="true" style="margin-top: 10px">
      <el-form-item label="工程师名称">
        <el-input class="item-input" placeholder="请输入工程师名称" v-model="Search.Name" @click.native="getEngineer"></el-input>
      </el-form-item>
      <el-form-item label="办事处">
        <el-cascader style="width: 260px" :options="Provinces" v-model="Search.Place" clearable @active-item-change="handleItemChange" :props="{value: 'Id', label: 'Name', children: 'children'}" placeholder="请选择办事处（省/市/区）"></el-cascader>
      </el-form-item>
      <el-form-item style="margin-left: 20px;">
        <el-button type="primary" style="width: 120px;" :loading="IsLoading" @click="getEngineer">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :loading="IsLoading" element-loading-text="加载中" :data="Engineers" class="table-shin-expand">
      <el-table-column type="expand">
        <template scope="props">
          <el-form class="inner-form" :inline="true" label-width="120px" label-suffix="：">
            <el-form-item label="身份证">{{props.row.IdCard}}</el-form-item>
            <el-form-item label="邮箱">{{props.row.Email}}</el-form-item>
            <el-form-item label="电话">{{props.row.Mobile}}</el-form-item>
            <el-form-item label="QQ">{{props.row.QQ}}</el-form-item>
            <el-form-item label="微信">{{props.row.Weixin}}</el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="编号" prop="Code"></el-table-column>
      <el-table-column label="工程师名称" prop="Name"></el-table-column>
      <el-table-column label="办事处" width="300px" prop="StreetAddress"></el-table-column>
      <el-table-column label="操作" width="220px">
        <template scope="props">
          <el-button type="text" @click="handleOpenDialog(props.row)">编辑</el-button>
          <el-button type="text" class="danger" @click="handleRemoveEngineer(props.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <engineer-dialog name="engineer" :show.sync="Dialog.show" :title="Dialog.Form.Id ? '编辑工程师':'新增工程师'" :form="Dialog.Form" @confirm="handleEngineerConfirm"></engineer-dialog>

  </div>
</template>

<script>
import EngineerDialog from './EngineerDialog'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Name: null,
        Place: [],
      },
      Dialog: {
        show: false,
        Form: {},
      },
      Provinces: [],
      Engineers: [],
      IsLoading: false,
    }
  },
  methods: {
    handleOpenDialog(Engineer = {}) {
      this.Dialog.show = true
      this.$set(this.Dialog, 'Form', Object.assign({}, Engineer))
    },
    handleEngineerConfirm(Form) {
      Form.IsEngineer = true
      let promise
      if (Form.Id) {
        promise = o(`Partner(${Form.Id})`).patch(Form).save()
      } else {
        promise = o('Partner').post(Form).save()
      }
      promise.then(() => {
        this.$message.success('保存成功')
        this.Dialog.show = false
        this.getEngineer()
      }).catch((error) => {
        this.$alert(error.message)
      })
    },
    handleRemoveEngineer(Form) {
      this.$confirm('即将删除工程师，请慎重操作！', '删除工程师', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        o(`Partner(${Form.Id})`).remove().save()
        .then(() => {
          this.$message.success('删除成功')
          this.getEngineer()
        })
      }).catch(() => { })
    },
    getEngineer() {
      this.IsLoading = true
      const Query = o('Partner')
      let filters = []
      if (this.Search.Name) {
        filters.push(`contains(Name, '${this.Search.Name}')`)
      }
      if (this.Search.Place.length > 0) {
        const ProvinceId = this.Search.Place[0]
        const CityId = this.Search.Place[1]
        const CountyId = this.Search.Place[2]
        filters.push(`(ProvinceId eq ${ProvinceId} and CityId eq ${CityId} and CountyId eq ${CountyId})`)
      }
      filters.push('IsEngineer eq true')
      Query.filter(filters.join(' and '))
      Query.expand('Province')
      .expand('City')
      .expand('County')
      .get().then(({data}) => {
        this.IsLoading = false
        this.Engineers = data.map(item => {
          if (item.Province && item.City && item.County) {
            item.StreetAddress = item.Province.Name + item.City.Name + item.County.Name + item.Street
          }
          return item
        })
      })
    },
    getProvinces() {
      o('Province').get().then(({ data }) => {
        this.Provinces = data.map(province => {
          province.children = []
          return province
        })
      })
    },
    handleItemChange(val) {
      const Province = this.Provinces.find((province) => province.Id === val[0])
      let City
      if (val[1]) {
        City = Province.children.find((city) => city.Id === val[1])
      }
      if (Province.children.length === 0) {
        o('City').filter(`Province/Id eq ${val}`).get().then(({ data }) => {
          this.$set(Province, 'children', data.map(city => {
            city.children = []
            return city
          }))
        })
      } else if (City && City.children.length === 0) {
        o('County').filter(`City/Id eq ${val[1]}`).get().then(({ data }) => {
          this.$set(City, 'children', data)
        })
      }
    },

  },
  created() {
    this.getEngineer()
    this.getProvinces()
  },
  components: {
    EngineerDialog,
  },
}
</script>

<style lang="less" scoped>
.item-input {
  width: 260px;
}

.danger {
  color: #ff4949;
}
.page-title3{font-size: 18px;padding-bottom: 15px;}
</style>

<style lang="less">
.engineer-page .inner-form .el-form-item__content {
  min-width: 150px;
}
</style>




// WEBPACK FOOTER //
// EngineerModule.vue?dd37cc02